<template>
  <b-modal :active.sync="isComponentModalActive"
           has-modal-card
           trap-focus
           width="960"
           :can-cancel="false"
           aria-role="dialog"
           aria-modal>
  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Select the shipping country</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Country"
                  custom-class="required-field"
                  :type="{'is-danger': errors.has('shipping_address_modal.country')}"
                  :message="errors.first('shipping_address_modal.country')">
          <b-select placeholder="Select a country" expanded
                    v-model=selectedCountry
                    v-on:input="onCountryChange()"
                    v-validate="'required'"
                    data-vv-scope="shipping_address_modal"
                    name="country">
              <option
                v-for="option in cpCountries"
                :value="option.country_reference"
                :key="option.note">
                {{ option.country_reference + ' - ' + option.note }}
              </option>
          </b-select>
        </b-field>
        <b-field label="State"
                  custom-class="required-field"
                  v-show="showStatesSelect"
                  :type="{'is-danger': errors.has('shipping_address_modal.state')}"
                  :message="errors.first('shipping_address_modal.state')">
          <b-select placeholder="Select a state" expanded
                    v-model=selectedState
                    v-on:input="onStateChange()"
                    v-validate="{required: showStatesSelect}"
                    data-vv-scope="shipping_address_modal"
                    name="state">
              <option
                v-for="option in cpStates"
                :value="option.state_reference"
                :key="option.note">
                {{ option.state_reference + ' - ' + option.note }}
              </option>
          </b-select>
        </b-field>

        <div class="help is-danger" v-show="priceCheckError">
          <p>{{priceCheckError}}</p>
        </div>
      </section>
      <footer class="modal-card-foot is-pulled-right has-text-right is-block">
      <b-button v-on:click="closeModal">Cancel</b-button>
      <b-button v-on:click="save" type="is-primary">Save</b-button>
      </footer>
    </div>
  </form>
  </b-modal>
</template>
<script>
import Cloudprinter from '@/services/CloudprinterService'
import EventBus from '@/event-bus'

export default {
  props: {
    isComponentModalActive: Boolean
  },
  name: 'EditCountryModal',
  watch: {
    isComponentModalActive: function () {
      if (this.isComponentModalActive) {
        this.openModal()
      }
    }
  },
  data () {
    return {
      selectedCountry: '',
      selectedState: '',
      cpCountries: [],
      cpStates: [],
      showStatesSelect: false,
      shippingAddress: null,
      priceCheckError: null,
      priceCheckResponse: ''
    }
  },
  methods: {
    onCountryChange () {
      const countryObj = this.cpCountries.find((o) => o.country_reference === this.selectedCountry)
      if (countryObj.require_state === 1) {
        this.getStatesList(this.selectedCountry)
        this.showStatesSelect = true
      } else {
        this.showStatesSelect = false
      }
      this.priceCheckError = null
      this.selectedState = ''
    },
    onStateChange () {
      this.priceCheckError = null
    },
    save (e) {
      e.preventDefault()
      this.$validator.validate('shipping_address_modal.*').then((isValid) => {
        if (isValid) {
          this.$store.dispatch('loader/show')
          const priceCheckPromise = this.cpPriceCheck(this.selectedCountry, this.selectedState)
          priceCheckPromise.then(response => {
            if (response.data.error) {
              this.priceCheckError = 'The shipping is not possible. Please, contact support.'
              this.priceCheckResponse = null
            } else {
              this.priceCheckError = null
              this.priceCheckResponse = response.data
              this.$store.dispatch('cpOrder/setCountry', this.selectedCountry)
              this.$store.dispatch('cpOrder/setState', this.selectedState)
              this.$store.dispatch('cart/setCountry', this.selectedCountry)
              this.$store.dispatch('cart/setState', this.selectedState)
              this.$store.dispatch('cpOrder/updatePriceCheckData', {
                priceCheckResponse: this.priceCheckResponse,
                priceCheckError: null
              })
              this.closeModal()
            }
          }).catch(error => {
            this.priceCheckResponse = null
            this.priceCheckError = error.response.data.error.info
          }).finally(() => {
            this.$store.dispatch('loader/hide')
          })
        }
      })
    },
    getStatesList: function () {
      Cloudprinter.getStates(this.selectedCountry).then((response) => {
        this.cpStates = response.data.shipping_states
      })
    },
    closeModal () {
      EventBus.$emit('EditCountryModal-modal-close')
    },
    openModal () {
      this.cpCountries = this.$store.getters['cpOrder/allData'].cpCountries
      this.selectedCountry = this.$store.getters['cart/country']
      const countryObj = this.cpCountries.find((o) => o.country_reference === this.selectedCountry)
      this.showStatesSelect = false
      this.priceCheckError = null

      if (countryObj.require_state === 1) {
        this.getStatesList(this.selectedCountry)
        this.selectedState = this.$store.getters['cart/state']
        this.showStatesSelect = true
      }
    },
    cpPriceCheck (country, state = null) {
      const items = this.$store.getters['cart/itemsForPriceCheck']

      let priceCheckData = {
        'country': country,
        'items': items
      }
      if (state) {
        priceCheckData.state = state
      }

      return Cloudprinter.priceCheck(priceCheckData)
    }
  }
}
</script>
